// extracted by mini-css-extract-plugin
export default {"tariffManagement":"BaseSubscription__tariffManagement--gAl75"};